import angular, { IScope, ITimeoutService } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import { ValidateService } from '@b2b/common/services/validate';
import moment from 'moment';

TemplatesCreateFlexpayCreateScheduleController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'ApiService',
  'HelpersService',
  'TemplatesService',
  'CalendarService',
  'ValidateService',
  'WizardFactory',
  'UserPreferencesService',
];

function TemplatesCreateFlexpayCreateScheduleController(
  $scope: IScope & { templatesCreateFlexpayCreateSchedule: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  HelpersService: TODO,
  TemplatesService: TODO,
  CalendarService: TODO,
  ValidateService: ValidateService,
  WizardFactory: TODO,
  UserPreferencesService: TODO
) {
  const ctrl = {
    model: {} as TODO,

    showWeekdays: false,
    startTime: new Date(),
    endTime: new Date(),
    getEth: HelpersService.getEth,
    dateFormats: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
    repeatTypes: TemplatesService.repeatTypes,
    repeatMonthTypes: TemplatesService.repeatMonthTypes,
    flexpayTypes: TemplatesService.flexpay.types,
    getRepeatMonthType: TemplatesService.getRepeatMonthType,
    getFlexpayType: TemplatesService.flexpay.getFlexpayType,
    selectedDiscount: {} as TODO,
    scheduleHours: [] as TODO[],
    scheduleRepeatMonthType: 'date',
    repeatMonthType: {} as TODO,
    repeatFrequency: {} as TODO,
    scheduleEndTime: null as TODO,
    isRepeating: false,
    repeatDays: {
      Su: false,
      M: false,
      Tu: false,
      W: false,
      Th: false,
      F: false,
      Sa: false,
    },

    wizard: {} as TODO,
    discountCodes: [] as TODO[],
    scheduleRangeHours: [] as TODO[],

    init: function () {
      if ($state.params && $state.params.scheduleId) {
        ctrl.model = TemplatesService.flexpay.getScheduleById($state.params.scheduleId).schedule;
      } else {
        ctrl.model = TemplatesService.flexpay.getNewSchedule().schedule;
      }
      ctrl.initWizard();
      ValidateService.addFieldTests(ctrl.wizard.getStep('schedule').validators);

      if (ctrl.model) {
        ctrl.repeatFrequency = TemplatesService.getScheduleRepeatCycle(ctrl.model);
        ctrl.repeatMonthType = ctrl.getScheduleRepeatMonthType();
        ctrl.scheduleRangeHours = TemplatesService.flexpay.getScheduleRangeHours(ctrl.model);
        if (ctrl.model.effectiveStartTime) {
          ctrl.startTime = CalendarService.parseDate(ctrl.model.effectiveStartTime);
        } else {
          ctrl.startTime = new Date();
        }
        if (ctrl.model.effectiveEndTime) {
          ctrl.endTime = CalendarService.parseDate(ctrl.model.effectiveEndTime);
        } else {
          const currentTemplate = TemplatesService.getModel();
          const lastPublished = currentTemplate?.lastPublished || undefined;
          ctrl.endTime = moment(lastPublished).add(1,'years').toDate()
        }

        ctrl.setRepeatDays(ctrl.model.weekdays);
        $timeout(function () {
          ctrl.setRepeating();
        }, 0);
        //ctrl.checkRepeat();
      } else {
        if ($state.params && $state.params.scheduleId) {
          // No schedule exists but was referenced
          $scope.$emit('TemplatesCreateSchedulesCreateController::Error', {
            message: 'Schedule does not exist',
            callback: function () {
              window.history.go(-1);
            },
          });
        } else {
          // Should never occur but in case they arrive at this state manually we will throw a message
          $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: 'Schedule could not be created' });
        }
      }

      $scope.$on('TemplatesCreateSchedulesCreateController::Save', ctrl.onTemplatesCreateSchedulesCreateControllerSave);

      console.log('TemplatesCreateSchedulesCreateTimesController::init');

      ctrl.getDiscounts();
    },

    initWizard: function () {
      ctrl.wizard = new WizardFactory();
      ctrl.wizard.init({
        name: 'schedule',
        validators: [
          {
            field: 'templates-create-flexpay-create-schedule-times-ends',
            equal: {
              message: 'Invalid end date',
              test: function () {
                return [true, ctrl.endTime instanceof Date];
              },
            },
          },
          {
            field: 'templates-create-flexpay-create-schedule-times-ends',
            equal: {
              message: 'Invalid start date',
              test: function () {
                return [true, ctrl.startTime instanceof Date];
              },
            },
          },
          {
            field: 'templates-create-flexpay-create-schedule-times-ends',
            greater: {
              message: 'End date cannot be sooner than start date',
              test: function () {
                let r = {
                  greater: 1,
                  less: 0,
                  equalTo: false,
                };

                if (ctrl.repeatFrequency.value === 'never') {
                  r = {
                    greater: 1,
                    less: 0,
                    equalTo: true,
                  };
                } else {
                  r = {
                    greater: ctrl.endTime ? ctrl.endTime.getTime() : 0,
                    less: ctrl.startTime ? ctrl.startTime.getTime() : 1,
                    equalTo: true,
                  };
                }

                return r;
              },
            },
          },
          // This is created during initialization
          {
            field: 'templates-create-flexpay-create-schedule-range-0',
            greater: {
              message: 'Hours cannot end before they begin',
              test: function () {
                return {
                  greater: ctrl.scheduleRangeHours[0].end.getTime(),
                  less: ctrl.scheduleRangeHours[0].start.getTime(),
                };
              },
            },
          },
        ],
      });
    },

    getDiscounts: function () {
      ApiService.discounts
        .list('v2', HelpersService.getPaginator())
        .then(ctrl.success.getDiscounts, ctrl.error.getDiscounts);
    },

    addHour: function () {
      ctrl.model.hours.push(TemplatesService.createHour());
      ctrl.scheduleHours.push(TemplatesService.hourToDate(ctrl.model.hours[ctrl.model.hours.length - 1]));
    },

    removeHour: function (index) {
      ctrl.model.hours.splice(index, 1);
      ctrl.scheduleHours.splice(index, 1);
    },

    addRange: function () {
      var index;

      if (!ctrl.model.ranges) {
        ctrl.model.ranges = [];
      }
      ctrl.model.ranges.push(TemplatesService.createRange());
      ctrl.scheduleRangeHours.push({
        end: TemplatesService.hourToDate(ctrl.model.ranges[ctrl.model.ranges.length - 1].end),
        start: TemplatesService.hourToDate(ctrl.model.ranges[ctrl.model.ranges.length - 1].start),
      });

      index = ctrl.scheduleRangeHours.length - 1;

      ctrl.wizard.addValidator('schedule', {
        field: 'templates-create-flexpay-create-schedule-range-' + index,
        greater: {
          message: 'Hours can not end before they begin',
          test: function () {
            return {
              greater: ctrl.scheduleRangeHours[index].start.getTime(),
              less: ctrl.scheduleRangeHours[index].end.getTime(),
              equalTo: true,
            };
          },
        },
      });
    },

    removeRange: function (index) {
      ctrl.model.ranges.splice(index, 1);
      ctrl.scheduleRangeHours.splice(index, 1);
      ctrl.wizard.removeValidator('schedule', 'templates-create-flexpay-create-schedule-range-' + index);
    },

    updateScheduleHours: function (index) {
      var d;

      if (ctrl.model.hours[index]) {
        d = new Date(ctrl.scheduleHours[index]);
        ctrl.model.hours[index].hour = parseInt(d.getHours(), 10);
        ctrl.model.hours[index].minutes = parseInt(d.getMinutes(), 10);
      }
    },

    updateScheduleRangeHours: function (index) {
      var ds, de;

      if (ctrl.model.range) {
        ds = new Date(ctrl.scheduleRangeHours[index].start);
        de = new Date(ctrl.scheduleRangeHours[index].end);
        ctrl.model.range.start.hour = parseInt(ds.getHours(), 10);
        ctrl.model.range.start.minutes = parseInt(ds.getMinutes(), 10);
        ctrl.model.range.end.hour = parseInt(de.getHours(), 10);
        ctrl.model.range.end.minutes = parseInt(de.getMinutes(), 10);
      }
    },

    getScheduleRepeatMonthType: function () {
      var i,
        ii,
        r = ctrl.repeatMonthTypes[0];

      for (i = 0, ii = ctrl.repeatMonthTypes.length; i < ii; i++) {
        if (ctrl.model.repeatMonthType === ctrl.repeatMonthTypes[i].value) {
          r = ctrl.repeatMonthTypes[i];
          break;
        }
      }

      return r;
    },

    setRepeating: function () {
      console.log(
        'setRepeating',
        ctrl.repeatFrequency.value,
        ctrl.scheduleEndTime,
        ctrl.model.effectiveEndTime,
      );
      ctrl.isRepeating = ctrl.repeatFrequency.value && ctrl.repeatFrequency.value !== 'never';
      ctrl.model.repeatCycle = ctrl.repeatFrequency.value;

      if (ctrl.model.repeatCycle === 'day') {
        ctrl.showWeekdays = false;
      } else if (ctrl.model.repeatCycle === 'week') {
        ctrl.showWeekdays = true;
      } else if (ctrl.model.repeatCycle === 'month') {
        if (ctrl.model.monthly instanceof Array && ctrl.model.monthly.length > 0) {
          ctrl.repeatMonthType = ctrl.getRepeatMonthType(ctrl.model.monthly[0]);
          ctrl.showWeekdays = true;
        } else if (ctrl.model.daysOfMonth instanceof Array && ctrl.model.daysOfMonth.length > 0) {
          ctrl.repeatMonthType = ctrl.getRepeatMonthType('date');
          ctrl.showWeekdays = false;
        }
      }
    },

    setRepeatDays: function (days) {
      var day;

      if (days instanceof Array) {
        for (day in ctrl.repeatDays) {
          if (ctrl.repeatDays.hasOwnProperty(day)) {
            ctrl.repeatDays[day] = days.indexOf(day) !== -1;
          } else {
            ctrl.repeatDays[day] = false;
          }
        }
      }
    },

    getRepeatDays: function () {
      const days: string[] = [];

      for (const day in ctrl.repeatDays) {
        if (ctrl.repeatDays.hasOwnProperty(day) && ctrl.repeatDays[day] === true) {
          days.push(day);
        }
      }
      return days;
    },

    isRepeatCycle: function (cycle) {
      return ctrl.repeatFrequency.value === cycle;
    },

    isRepeatMonthType: function (type) {
      return ctrl.repeatMonthType.value === type;
    },

    addDayOfMonth: function (index, fieldId) {
      ctrl.model.daysOfMonth.push(1);
      //next tick
      $timeout(function () {
        ctrl.setInputFocus(ctrl.model.daysOfMonth.length - 1, fieldId);
      }, 0);
    },

    removeDayOfMonth: function (index, fieldId) {
      ctrl.model.daysOfMonth.splice(index, 1);
      //next tick
      $timeout(function () {
        ctrl.setInputFocus(index - 1, fieldId);
      }, 0);
    },

    setInputFocus: function (index, fieldId) {
      const el: JQuery<HTMLElement> = $('#' + fieldId + '-' + (index || 0));
      if (el.length) {
        el.get(0)?.focus();
      }
    },

    checkRepeat: function () {
      var showWeekdays = false,
        sDate;

      if (ctrl.isRepeatCycle('day')) {
        ctrl.model.weekdays = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
        ctrl.model.daysOfMonth = null;
        ctrl.model.monthly = null;
      } else if (ctrl.isRepeatCycle('week')) {
        ctrl.model.monthly = null;
        ctrl.model.daysOfMonth = null;
        showWeekdays = true;
      } else if (ctrl.isRepeatCycle('month') && ctrl.repeatMonthType.value !== 'date') {
        ctrl.model.monthly = [ctrl.repeatMonthType.value];
        ctrl.model.daysOfMonth = null;
        showWeekdays = true;
      } else {
        if (!ctrl.startTime.hasOwnProperty('getDate')) {
          sDate = new Date(ctrl.startTime);
        }
        ctrl.endTime = ctrl.startTime;
        ctrl.model.monthly = null;
        if (!(ctrl.model.daysOfMonth instanceof Array && ctrl.model.length > 0)) {
          ctrl.model.daysOfMonth = [1];
        }
        ctrl.model.weekdays = [];
      }

      ctrl.showWeekdays = showWeekdays;

      ctrl.setRepeating();
    },

    findDiscount: function (id) {
      let r: TODO = false;

      for (let i = 0, ii = ctrl.discountCodes.length; i < ii; i++) {
        const discount = ctrl.discountCodes[i];

        if (discount.id === id) {
          r = {
            index: i,
            discount: discount,
          };
          break;
        }
      }

      return r;
    },

    success: {
      init: function (response) {
        // noop
      },
      getDiscounts: function (response) {
        ctrl.discountCodes = response.data.payload.list;
        ctrl.selectedDiscount = {};

        const discountFind = ctrl.findDiscount(ctrl.model.discountId);
        if (discountFind) {
          ctrl.selectedDiscount = discountFind.discount;
        }
      },
    },

    error: {
      init: function (response) {
        // noop
      },
      getDiscounts: function (response) {
        // noop
      },
    },

    onTemplatesCreateSchedulesCreateControllerSave: function () {
      if (!ctrl.startTime) {
        if (ctrl.endTime) {
          ctrl.startTime = ctrl.endTime;
        } else {
          ctrl.startTime = new Date();
        }
        ctrl.startTime = new Date(
          ctrl.startTime.getFullYear(),
          ctrl.startTime.getMonth(),
          ctrl.startTime.getDate(),
          0,
          0,
          0
        );
      }

      ctrl.model.effectiveStartTime = CalendarService.toISO8601(ctrl.startTime);
      ctrl.model.repeatCycle = ctrl.repeatFrequency.value;

        if (ctrl.model.repeatCycle === 'never') {
          ctrl.endTime = new Date(
            ctrl.startTime.getFullYear(),
            ctrl.startTime.getMonth(),
            ctrl.startTime.getDate(),
            23,
            59,
            59
          );
        }
        ctrl.model.effectiveEndTime = CalendarService.toISO8601(ctrl.endTime);

      // Only assign weekdays when visible
      if (ctrl.showWeekdays) {
        ctrl.model.weekdays = ctrl.getRepeatDays();
      }

      /**
       *
       *  Disabled discount option
       *
       *  if (ctrl.model.type === 'discount' && ctrl.selectedDiscount) {
       *     ctrl.model.discountId = ctrl.selectedDiscount.id;
       *  }else{
       *    ctrl.model.discountId = null;
       *  }
       *
       */

      // Force pay what you wish
      ctrl.model.type = ctrl.getFlexpayType(ctrl.flexpayTypes, 'payWhatYouWish').value;

      TemplatesService.flexpay.setSchedule(ctrl.model);
      TemplatesService.flexpay.verifySchedules();

      ctrl.wizard.validate();
    },

    // onIndefiniteUpdate: function (n, o) {
    //   if (n) {
    //     ctrl.model.effectiveEndTime = null;
    //   } else {
    //     ctrl.model.effectiveEndTime = CalendarService.toISO8601(ctrl.endTime);
    //   }
    // },
  };

  $scope.templatesCreateFlexpayCreateSchedule = ctrl;
  ctrl.init();
}

export const TemplatesCreateFlexpayCreateScheduleControllerModule = angular
  .module('acme.view.application.templates.create.flexpay.create.schedule.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.templates',
    'acme.common.service.validate',
    'acme.common.factory.wizard',
    'acme.common.service.userPreferences',
  ])

  .controller('TemplatesCreateFlexpayCreateScheduleController', TemplatesCreateFlexpayCreateScheduleController).name;
